export class UserPunch {
  UserPunchSearchDate: any;
}



// WEBPACK FOOTER //
// ./src/app/Classes/UserPunch.ts